export default {
    driver_performance_case_overview_eventName: "Event Type",
    driver_performance_case_overview_count: "Count",
    driver_performance_case_overview_priorCoaching: "Prior Coaching",
    driver_performance_case_overview_caseId: "Case ID",
    driver_performance_case_overview_status: "Status",
    driver_performance_case_overview_created: "created",
    driver_performance_case_overview_piSuccess: "PI Success",
    driver_performance_case_overview_metric: "Metric",
    driver_performance_case_overview_measure: "Measure",
    driver_performance_case_overview_risk: "Risk",
    driver_performance_case_overview_coachingHistory: "Coaching History",
    driver_performance_case_overview_performanceHistory: "Performance History",
    driver_performance_case_totalEvents: "Total Events",
    driver_performance_case_avgEvents: "Average Risk Event",
    driver_performance_case_riskScore: "Risk Score",
    driver_performance_case_totalDistance: "Total Distance",
    driver_performance_case_pendingAssing: "Pending",
    driver_performance_case_pendingAssign: "Pending",
    driver_performance_case_pendingInitiate: "Pending",
    driver_performance_case_Expired: "Expired",
    driver_performance_case_evaluate: "Evaluate",
    driver_performance_case_completedOmitedPI: "Completed",
    driver_performance_case_completed: "Completed",
    driver_performance_case_evaluateJudgement: "Evaluate",
    driver_performance_case_escalateMonitor: "Escalate",
    driver_performance_case_escalateJudgement: "Escalate",
    driver_performance_case_completedFailedPI: "Completed",
    driver_performance_case_AssingCoach: "Assign Coach",
    driver_performance_case_AssignCoach: "Assign Coach",
    driver_performance_case_InitiateCoaching: "Initiate Coaching",
    driver_performance_case_Monitor: "Monitor",
    driver_performance_case_PIOmited: "PI Omited",
    driver_performance_case_PISuccessfull: "PI Successfull",
    driver_performance_case_Judgement: "Judgement",
    driver_performance_case_Monitoring: "Monitoring",
    driver_performance_case_Judging: "Judging",
    driver_performance_case_PIFailed: "PI Failed",
    driver_performance_case_yes: "Yes",
    driver_performance_case_no: "No",
    driver_performance_case_expired: "Expired",
}
